import React from 'react';

import { AvatarSize } from './constants';

type AvatarGroupContextType =
  | {
      size?: AvatarSize;
    }
  | undefined;

const AvatarGroupContext =
  React.createContext<AvatarGroupContextType>(undefined);

export default AvatarGroupContext;
